<template>
    <!-- Desktop (keeps UiModal) -->
    <UiModal
        v-if="!isMobile"
        :is-open="isOpen"
        title="Benefits Disclosure"
        @close="closeModal"
        width="400px"
    >
        <template #content>
            <div>
                <!-- Art header -->
                <div class="flex justify-center pb-8">
                    <img
                        :src="coinCalImage"
                        alt="Benefits"
                        class="w-32 h-24 object-contain"
                    />
                </div>

                <!-- Content -->
                <div>
                    <p class="text-sm text-slate-600 dark:text-slate-300 leading-6">
                        We do our best to keep benefit information up to date,
                        but card issuers can change benefits at any time. Please
                        confirm benefit details directly with the issuer before
                        making a purchase based on a listed benefit.
                    </p>
                </div>
            </div>
        </template>
    </UiModal>

    <!-- Mobile using UiModalMobile -->
    <UiModalMobile
        v-if="isMobile"
        :is-open="isOpen"
        title="Benefits Disclosure"
        @close="closeModal"
    >
        <template #content>
            <div>
                <!-- Art header with gradient -->
                <div
                    class="relative rounded-lg overflow-hidden flex justify-center py-6 mb-4"
                >
                    <img
                        :src="coinCalImage"
                        alt="Benefits"
                        class="w-28 h-28 object-contain"
                    />
                </div>

                <p class="text-slate-600 dark:text-slate-300 text-sm leading-6">
                    We do our best to keep benefit information up to date, but
                    card issuers can change benefits at any time. Please confirm
                    benefit details directly with the issuer before making a
                    purchase based on a listed benefit.
                </p>
            </div>
        </template>
        <template #footer>
            <button
                type="button"
                class="w-full h-11 rounded-lg bg-slate-800 dark:bg-slate-700 text-white text-sm font-medium"
                @click="closeModal"
            >
                Got it
            </button>
        </template>
    </UiModalMobile>
</template>

<script setup>
import { useIsMobile } from '@/composables/useIsMobile';
import UiModal from '@/components/ui/modal/ui-modal.vue';
import UiModalMobile from '@/components/ui/modal/ui-modal-mobile.vue';
import coinCalImage from '../../images/coin-cal.png';

defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['close']);

const { isMobile } = useIsMobile();

const closeModal = () => {
    emit('close');
};
</script>
